import React from 'react'
import PageBlocks from '../../cms-page-blocks/list'

const EditPageBlocks = props => (
  <PageBlocks
    target='cms_page_blocks'
    cmsPageProp='cms_page_id'
    cmsPageId={props.params.cmsPageId}
    route={props.route}
  />
)

export default EditPageBlocks
